import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import { Toggletip } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';

const Reorder = ({ id , isReorderAvailable , onReorder  })=>{
    const intl = useIntl();
    return /*#__PURE__*/ React.createElement(Card.Section, {
        className: "reorder"
    }, isReorderAvailable && onReorder ? /*#__PURE__*/ React.createElement(Card.Link, {
        iconBefore: "add-to-cart",
        onClick: ()=>onReorder(id)
        ,
        variant: "caption-head"
    }, intl.getLabel('cart.actions.addToCart')) : /*#__PURE__*/ React.createElement(Card.Section, {
        className: "reorder__unavailable"
    }, /*#__PURE__*/ React.createElement(Card.Text, {
        component: "span",
        variant: "caption",
        color: "text-secondary"
    }, intl.getLabel('account.reorder.notReorderable')), /*#__PURE__*/ React.createElement(Toggletip, {
        message: intl.getLabel('account.reorder.notReorderable.tooltip')
    })));
};

export { Reorder as default };
//# sourceMappingURL=Reorder.js.map
